import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../lib/api';

function BulkUpdateModal({ holdings, category, onClose, onSuccess }) {
  const [updatedValues, setUpdatedValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (holdingId, value) => {
    setUpdatedValues(prev => ({
      ...prev,
      [holdingId]: value,
    }));
  };

  const handleSaveAll = async () => {
    setLoading(true);
    setError(null);

    const updates = Object.entries(updatedValues).map(([holdingId, manualCurrentValue]) => ({
      holdingId,
      manualCurrentValue,
    }));

    try {
      await axios.put(`${API_BASE_URL}/holdings/bulk-update`, { updates }, { withCredentials: true });
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update holdings');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Update values for {category}</h2>
        {error && <div className="error-message">{error}</div>}
        <table>
          <thead>
            <tr>
              <th>Asset Name</th>
              <th>Current Value</th>
              <th>New Value</th>
            </tr>
          </thead>
          <tbody>
            {holdings.map(holding => (
              <tr key={holding.holdingId}>
                <td>{holding.assetName}</td>
                <td>{holding.manualCurrentValue}</td>
                <td>
                  <input
                    type="number"
                    value={updatedValues[holding.holdingId] || ''}
                    onChange={(e) => handleChange(holding.holdingId, e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="form-actions">
          <button onClick={onClose} className="btn-cancel" disabled={loading}>Close</button>
          <button onClick={handleSaveAll} className="btn-submit" disabled={loading}>
            {loading ? 'Saving...' : 'Save All'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BulkUpdateModal;